export default "__VITE_ASSET__BYAmv4Mf__"